module.exports = __webpack_public_path__ + "images/70f7f5fef421bbfe9b7fb3a28d8e6c24.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/react/images/uerm/IND-KSS-1-T.jpg
// module id = 776
// module chunks = 0